import React from "react";

interface TabLayoutProps {
  children: React.ReactNode;
  className?: string;
}
export const TabContent = ({ children, className = "" }: TabLayoutProps): JSX.Element | null => {
  return <div className={`py-4 ${className}`}>{children}</div>;
};

interface TabHeaderProps {
  children: React.ReactNode;
  subHeader?: string | React.ReactNode;
}
export const TabHeader = ({ children, subHeader }: TabHeaderProps): JSX.Element => {
  return (
    <h2 className="mb-6 text-xl font-bold text-slate-800 sm:text-center dark:text-slate-100">
      {children}
      {subHeader && <div className="text-sm font-normal text-gray-400">{subHeader}</div>}
    </h2>
  );
};
export const TabGrid = ({ children }: React.PropsWithChildren): JSX.Element => {
  return <div className="grid auto-cols-min grid-cols-1 gap-4 lg:grid-cols-2">{children}</div>;
};
